import React from "react";
import { Text, Button, Tooltip } from "@fluentui/react-components";
import { SignOutFilled } from "@fluentui/react-icons";
import { useAdminAuth } from "./AdminAuthContext";

function AdminLogout() {
  const { userInfo, logout } = useAdminAuth();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      {userInfo?.displayName && (
        <Text weight="medium">{userInfo?.displayName}</Text>
      )}
      <Tooltip content="Logout" relationship="label">
        <Button
          appearance="transparent"
          icon={<SignOutFilled />}
          onClick={logout}
          aria-label="More options"
        />
      </Tooltip>
    </div>
  );
}

export default AdminLogout;
